// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5e609792","796":"09a7a0a1"}[chunkId] + ".chunk.js";
};